import { HttpClient } from '@angular/common/http';
import { FeatureService } from './feature.service';

export function featureFactory(
  svc: FeatureService,
  http: HttpClient
): () => Promise<void> {
  return () => svc.init(http);
}
